"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function SimilarTournamentsConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <Carousel opts={{
      align: "start"
    }} className="w-full">
        <CarouselContent>
          {[...Array(4)].map((_, i) => <CarouselItem key={i} data-index={i} className="md:basis-1/2 lg:basis-1/3">
              <div className="h-[380px] w-full animate-pulse rounded-xl bg-muted"></div>
            </CarouselItem>)}
        </CarouselContent>
      </Carousel>;
  }
  if (error) {
    return <div className="rounded-xl border border-destructive/20 bg-destructive/10 p-6 text-center text-destructive">
        <p>Impossible de charger les tournois pour le moment.</p>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="rounded-xl border border-border bg-muted/30 p-12 text-center text-muted-foreground">
        <p>Aucun tournoi similaire trouvé.</p>
      </div>;
  }
  return <Carousel opts={{
    align: "start",
    loop: true
  }} className="w-full">
      <CarouselContent>
        {posts.map((post, i) => <CarouselItem key={post.id} data-index={i} className="md:basis-1/2 lg:basis-1/3">
            <Link to={post.link || "#"} className="group block h-full">
              <Card className="flex h-full flex-col overflow-hidden rounded-xl border border-transparent bg-secondary transition-colors duration-300 hover:border-primary">
                <div className="relative h-56 w-full overflow-hidden bg-muted">
                  {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="h-full w-full object-cover grayscale contrast-125 transition-all duration-500 group-hover:scale-105" /> : <div className="flex h-full w-full items-center justify-center bg-secondary-foreground/5">
                      <span className="text-sm text-muted-foreground">
                        Image non disponible
                      </span>
                    </div>}
                  {}
                  <div className="absolute inset-0 bg-gradient-to-t from-secondary/80 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
                </div>
                <CardContent className="flex flex-grow flex-col justify-between p-6">
                  <h3 className="mb-6 line-clamp-2 font-default text-2xl font-semibold text-secondary-foreground">
                    {post.title}
                  </h3>
                  <div className="mt-auto flex items-center text-primary">
                    <span className="mr-3 text-sm font-semibold uppercase tracking-wider">
                      Voir les détails
                    </span>
                    <ArrowRight className="h-5 w-5 transition-transform duration-300 ease-out group-hover:translate-x-2" />
                  </div>
                </CardContent>
              </Card>
            </Link>
          </CarouselItem>)}
      </CarouselContent>
      <div className="mt-8 flex items-center justify-end gap-4 pr-4 md:hidden">
        <CarouselPrevious className="static translate-x-0 translate-y-0" />
        <CarouselNext className="static translate-x-0 translate-y-0" />
      </div>
      <div className="hidden md:block">
        <CarouselPrevious className="-left-4 bg-background/80 backdrop-blur-sm hover:bg-primary hover:text-primary-foreground" />
        <CarouselNext className="-right-4 bg-background/80 backdrop-blur-sm hover:bg-primary hover:text-primary-foreground" />
      </div>
    </Carousel>;
}
export default function SimilarTournaments() {
  const wp_query_params = {
    post_type: "post",
    per_page: 6,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="tournois-similaires" className="relative w-full overflow-hidden bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 md:mb-16">
          <h2 className="font-default text-3xl font-bold tracking-tight text-foreground md:text-4xl lg:text-5xl">
            Plus de compétitions d'élite
          </h2>
          <div className="mt-4 h-1.5 w-24 origin-left -rotate-3 transform rounded-full bg-primary"></div>
        </div>

        <PostsProvider className="similar-tournaments-wrapper" wp_query={{
        post_type: "post",
        per_page: 6,
        orderby: "date",
        order: "desc"
      }}>
          <SimilarTournamentsConsumer />
        </PostsProvider>
      </div>
    </section>;
}